import http from "../http-common";

//const API_URL = 'http://localhost:8080/api/auth/';
const API_URL = '/auth/';

export default class AuthService {
  login(user) {
    //alert('user = '+ JSON.stringify(user));
    return http
      .post(API_URL + 'login', user)
      .then(response => response.data);
  }

  logout(user) {
    return http
      .post(API_URL + 'logout', user)
      .then(response => {
        localStorage.removeItem('user');
        localStorage.removeItem('token');

        // localStorage.clear();
        // sessionStorage.clear();
        return response.data;
      });
  }

  register(user) {
    return http.post(API_URL + 'signup', {
      username: user.username,
      email: user.email,
      password: user.password
    });
  }

  handleResponse(response) {
    if(response.status === 401) {
      this.logout();
      location.reload(true);

      const error = response.data && response.data.message;
      return Promise.reject(error);
    }

    return Promise.resolve(response);

  }
  
}